import { render } from "./ChapterLabel.vue?vue&type=template&id=720d5832&scoped=true"
import script from "./ChapterLabel.vue?vue&type=script&lang=js"
export * from "./ChapterLabel.vue?vue&type=script&lang=js"

import "./ChapterLabel.vue?vue&type=style&index=0&id=720d5832&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-720d5832"]])

export default __exports__